import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
const ProductPageSectionTitle = t0 => {
  const $ = _c(8);
  let children;
  let otherProps;
  let t1;
  if ($[0] !== t0) {
    ({
      className: t1,
      children,
      ...otherProps
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = otherProps;
    $[3] = t1;
  } else {
    children = $[1];
    otherProps = $[2];
    t1 = $[3];
  }
  const className = t1 === undefined ? "" : t1;
  const t2 = `text-3xl font-bold text-gray lg:mb-[.6rem] ${className}`;
  let t3;
  if ($[4] !== children || $[5] !== otherProps || $[6] !== t2) {
    t3 = <h2 {...otherProps} className={t2}>{children}</h2>;
    $[4] = children;
    $[5] = otherProps;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
ProductPageSectionTitle.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node
};
export default ProductPageSectionTitle;